module.exports = __webpack_public_path__ + "static/img/son4_active.f6409f7e.png";